<page-heading
  [title]="'integrations.santriList.pageTitle' | translate"
  [description]="'integrations.santriList.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-9 input-trend-search">
            <input
              type="search"
              #searchBox
              class="form-control"
              [placeholder]="'integrations.santriList.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)"
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="showNewWebhook()">
              {{ 'integrations.santriList.addButton' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  @if (pager.total === 0) {
  <empty-records-legacy-component
    [labelButton]="'integrations.santriList.addButton' | translate"
    [buttonClass]="'btn btn-info fw-bold'"
    [subMessage]="'integrations.santriList.emptySubMessage' | translate"
    [message]="'integrations.santriList.emptyMessage' | translate"
    (emitEvent)="showNewWebhook()"
  />
  } @if(!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'integrations.santriList.columnCreatedAt' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.santriList.columnName' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.santriList.columnStatus' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.santriList.columnRequestsMonth' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.santriList.columnRequestsTotal' | translate }}</th>
          <th>
            <span class="sr-only"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (webhook of pager.list; track $index) {
        <tr (click)="showEditWebhook(webhook._id)" style="cursor: pointer">
          <td>
            <span>
              {{
                webhook.createdAt
                  | timezoneDate
                    : "DD/MM/YYYY"
                    : getTimezoneCompanyCurrentUser()
              }}
            </span>
          </td>
          <td>
            <strong class="text-truncate">{{ webhook.name }}</strong>
          </td>
          <td>
            <span>
              {{ webhook.actived ? ('integrations.santriList.statusActive' | translate) : ('integrations.santriList.statusTestMode' | translate) }}
            </span>
          </td>
          <td>
            <span>
              {{ webhook.requestMonth ?? "-" }}
            </span>
          </td>
          <td>
            <span>
              {{ webhook.requestTotal ?? "-" }}
            </span>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
                type="button"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>

              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="
                    showRequestsWebhook(webhook.uuid); $event.stopPropagation()
                  "
                >
                  {{ 'integrations.santriList.menuRequests' | translate }}
                </button>

                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="
                    showEditWebhook(webhook._id); $event.stopPropagation()
                  "
                >
                  {{ 'integrations.santriList.menuEdit' | translate }}
                </button>

                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="delete(webhook._id); $event.stopPropagation()"
                >
                  {{ 'integrations.santriList.menuRemove' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)" />
    }
  </div>
  }
</div>
